import { useMotionValueEvent, useScroll } from 'framer-motion'
import { throttle } from 'lodash'
import React, { useEffect, useState } from 'react'
import ReactGA from 'react-ga'
import { Link } from 'react-scroll'
import ym from 'react-yandex-metrika'

import { PhoneIcon } from '../icons/PhoneIcon'
import styles from './navMenu.module.scss'

export const NavMenu = ({
  menuItems,
  isHide,
  analyticsOther,
}: {
  menuItems: { name: string; linkId: string }[]
  isHide?: boolean | undefined
  analyticsOther?: (name: string) => void
}) => {
  const [isShowMenu, setIsShowMenu] = useState(false)
  const [isScrollAtBottom, setIsScrollAtBottom] = useState(false)

  const { scrollY } = useScroll()

  useMotionValueEvent(scrollY, 'change', latest => {
    if (isHide === undefined) {
      setIsShowMenu(latest > 50)
    } else {
      setIsShowMenu(latest > 50 && !isHide)
    }
  })

  const handleScroll = throttle(() => {
    const headerHeight = document.querySelector('header')?.offsetHeight || 0
    const footerHeight = document.querySelector('footer')?.offsetHeight || 0
    const windowHeight = window.innerHeight
    const scrollY = window.scrollY
    const bodyHeight = document.body.offsetHeight - headerHeight - footerHeight
    const threshold = 100
    const isAtBottom = scrollY + windowHeight >= bodyHeight + threshold

    setIsScrollAtBottom(isAtBottom)
  }, 100)

  const googleAnalytics = (name: string) => {
    ReactGA.ga('send', 'event', 'main', 'filters click', name)
    ym('reachGoal', 'filters click', {
      'filters click': {
        main: {
          'filters name': name,
        },
      },
    })
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)
    window.addEventListener('resize', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
      window.removeEventListener('resize', handleScroll)
    }
  }, [])

  useEffect(() => {
    setIsShowMenu(!isHide)
  }, [isHide])

  return (
    <>
      {/* {isShowMenu && ( */}
      <div
        className={`
            ${styles.navWrapperAbsolute} ${
          isScrollAtBottom && styles.navWrapper1
        } ${isShowMenu && styles.isVision}
          `}
      >
        <div className={`${styles.navWrapper} `}>
          <div className={styles.linksWrapper}>
            {menuItems.map(el => (
              <Link
                key={el.linkId}
                to={el.linkId.replace('/', '')}
                className={styles.link}
                smooth={true}
                onClick={() => {
                  if (analyticsOther) {
                    analyticsOther(el.name)
                  } else {
                    googleAnalytics(el.name)
                  }
                }}
                dangerouslySetInnerHTML={{ __html: el.name }}
              ></Link>
            ))}
          </div>
        </div>
        <Link
          to='#feedback'
          smooth={true}
          onClick={() => googleAnalytics('Форма обратной связи')}
          className={styles.logoBlock}
        >
          <PhoneIcon />
        </Link>
      </div>
      {/* )} */}
    </>
  )
}
